import { createCrudService } from '@/services/api/createCrudService'

export interface Specialty {
  id: string
  specialty: string
  code: string | null
  status: 'ATIVO' | 'INATIVO'
}

export const SpecialtiesService = createCrudService<Specialty>('/workflow/specialties', { searchField: 'specialty' })
